import { render, staticRenderFns } from "./eventCreate.vue?vue&type=template&id=540a2f4c"
import script from "./eventCreate.ts?vue&type=script&lang=ts&external"
export * from "./eventCreate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports